import React from "react";
import Section11B1 from "./Section11B1";
import Section11B2 from "./Section11B2";
import { useMediaQuery, Box } from "@mui/material";

const Section11B = ({ data, index }) => {
  // Breakpoints
  const isMobileOrLaptop = useMediaQuery("(max-width: 1200px)"); // Show for xs, sm, md, lg
  const isXLScreen = useMediaQuery("(min-width: 1201px)"); // Show for xl only

  return (
    <Box>
      {/* Section11A1 for Mobile and Laptop */}
      {isMobileOrLaptop && <Section11B1 data={data} index={index} />}

      {/* Section11A2 for XL Screens */}
      {isXLScreen && <Section11B2 data={data} index={index} />}
    </Box>
  );
};

export default Section11B;
